/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.14.0
 */

import { IFormAddressTranslation } from '../../types/modules/formAddress';

export const initialFormAddress: IFormAddressTranslation = {
    fields: {
        apartment: '',
        apartmentOptional: '',
        block: '',
        city: '',
        house: '',
        houseOptional: '',
        houseTooltip: '',
        planningElement: '',
        planningElementOptional: '',
        street: '',
        streetOptional: '',
        structure: '',
    },
    info: {
        address: {
            all: {
                link: '',
                text: '',
            },
            subs: {
                link: '',
                text: '',
            },
        },
    },
    types: {
        account: {
            title: '',
        },
        subscriber: {
            title: '',
        },
    },
};
